import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Button from "@mui/material/Button";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import {LocalizationProvider} from "@mui/x-date-pickers";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import {DesktopDatePicker} from "@mui/x-date-pickers/DesktopDatePicker";
import {TimePicker} from "@mui/x-date-pickers/TimePicker";
import {useEffect, useState} from "react";


const UpdateStatus = ({isModalOpen, handleModalClose, handleSubmit, form, setForm}) => {
    const [initialStatus, setInitialStatus] = useState(form.status);

    useEffect(() => {
        setInitialStatus(form.status);
    }, [form.status]);

    return (
        <Modal open={isModalOpen} onClose={handleModalClose} aria-labelledby="modal-modal-title" aria-describedby="modal-modal-description">
            <div className="customize-modal">
                <div className="modal-head">
                    <h2>Update Status</h2>
                    <IconButton className="close-modal-btn p-0" onClick={handleModalClose}>
                        <HighlightOffIcon/>
                    </IconButton>
                </div>
                <div className="modal-body-content">
                    <FormControl className="mb-4">
                        <FormLabel id="update_status" className="radio-label">
                            Please select an option to update the status of Application Filing
                        </FormLabel>
                        <RadioGroup row aria-labelledby="update_status" name="update_status" value={initialStatus} onChange={(e) => {
                            setInitialStatus(e.target.value);
                        }}>
                            <FormControlLabel value="Ack. Awaited" control={<Radio/>} label="Ack. Awaited"/>
                            <FormControlLabel value="Filed" control={<Radio/>} label="Filed"/>
                        </RadioGroup>
                    </FormControl>
                    <div className="row">
                        <div className="col-12">
                            <TextField
                                id="remarks"
                                label="Remarks"
                                variant="outlined"
                                className="w-100 mb-3"
                                value={form?.remarks}
                                onChange={(e) => {
                                    setForm((prevState) => {
                                        return {
                                            ...prevState,
                                            remarks: e.target.value
                                        };
                                    });
                                }}
                            />
                        </div>
                        <div className="col-md-6">
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DesktopDatePicker
                                    className="w-100 mb-3"
                                    label="Date of Filing:"
                                    inputFormat="MM/dd/yyyy"
                                    value={form?.filing_date}
                                    maxDate={new Date()}
                                    onChange={(event) => {
                                        setForm((prevState) => {
                                            return {
                                                ...prevState,
                                                filing_date: event
                                            };
                                        });
                                    }}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                        </div>
                        <div className="col-md-6">
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <TimePicker
                                    className="w-100 mb-3"
                                    label="Time of Filing:"
                                    value={form?.filing_date}
                                    onChange={(event) => {
                                        setForm((prevState) => {
                                            return {
                                                ...prevState,
                                                filing_date: event
                                            };
                                        });
                                    }}
                                    renderInput={(params) => <TextField {...params} />}
                                />
                            </LocalizationProvider>
                        </div>
                    </div>
                </div>
                <div className="modal-foot">
                    <Button
                        type="button"
                        disabled={form.status === initialStatus || !(form?.filing_date)}
                        className="btn-theme px-5"
                        onClick={() => {
                            setForm(prevState => {
                                const updatedForm = {
                                    ...prevState,
                                    status: initialStatus
                                };
                                handleSubmit(updatedForm);
                                return updatedForm;
                            });
                            handleModalClose();
                        }}
                    >
                        Update
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default UpdateStatus;